import { render, staticRenderFns } from "./department-dialog.vue?vue&type=template&id=658e1acf"
import script from "./department-dialog.vue?vue&type=script&lang=js"
export * from "./department-dialog.vue?vue&type=script&lang=js"
import style0 from "./department-dialog.vue?vue&type=style&index=0&id=658e1acf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports